"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    height: 32,
    width: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 1h32v32H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.002 1v1.999h-2V5h2v28h-24s-2 0-2-2V4.018L1.001 4c-.035-1.355.807-2.314 1.555-2.646.738-.362 1.362-.35 1.446-.354h23M3.998 5h19.004V2.999h-19c-.002.006-.032-.002-.149.019-.115.019-.274.06-.404.125-.253.171-.414.21-.447.857.015.5.134.609.272.743.144.126.401.212.579.239A.871.871 0 003.998 5m1.004 26h20V7h-20v24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 23v-2h12v2H7zm0-8v-2h16v2H7zm0 4v-2h16v2H7z"
  }));
}

var MemoSvgTemplate = /*#__PURE__*/React.memo(SvgTemplate);
var _default = MemoSvgTemplate;
exports["default"] = _default;